export default __webpack_public_path__ + "static/media/mobile_login_image.bd53542f.png";